import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';
import FileManager from './FileManagerCreate';

export type FileManagerDialogProps = {
   initialPath?: string;
   open: boolean;
   title?: string;
   filesOfType?: string[];
   directoriesOnly?: boolean;
   onConfirm: (path: string) => void;
   onClose: () => void;
};

const FileManagerDialog = memo(
   ({
      initialPath = '',
      open,
      title = DialogTypes.FileManager.dialogName,
      filesOfType,
      directoriesOnly,
      onClose,
      onConfirm,
   }: FileManagerDialogProps) => {
      const handleSelect = (filePath: string) => {
         onConfirm(filePath);
      };
      return (
         <DialogComponent open={open} maxWidth="md" header={title} close={onClose}>
            {open && (
               <FileManager
                  initialPath={initialPath}
                  directoriesOnly={directoriesOnly}
                  filesOfType={filesOfType}
                  onSelect={handleSelect}
                  onCancel={onClose}
               />
            )}
         </DialogComponent>
      );
   }
);

export default FileManagerDialog;
